// This function allow to reference chunks
__webpack_require__.u = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + "templates" + "." + "b1cddcd6ef1517e5" + ".js"
}